export const RF_NAME = 'COLLATERALS'

export const COLLATERALS_FETCHER_NAME = 'COLLATERALS'

export const LK_GRID_NAME = 'COLLATERALS'
export const formName = 'frm_collaterals'
export const objectName = 'dbgrd_collateral'
